module.exports = __webpack_public_path__ + "e18ded0f64a963d6b46273a0e98677df.png";